module.exports = __webpack_public_path__ + "static/img/img_organ.e4746ed9.png";